import i18n from 'i18n-js';

// Builds the NC file version label, e.g. "329 (favorite)" / "12 (latest)"; empty string when no version.
export const buildVersionLabel = (version: { sequenceNumber: number; isFavorite?: boolean } | null | undefined): string =>
  version ? `${version.sequenceNumber} (${i18n.t(version.isFavorite ? 'favorite' : 'latest')})` : '';
